import { useWindowSize } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { useLayoutEffect, useState, useRef, forwardRef } from 'react';
import { FormattedTime } from 'features/current_user';
const containerCss = "cvje4ql";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const positionWrapperCss = "pfv6d4g";
const PositionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(positionWrapperCss, props.className)} />;
});
const intervalInactiveCss = "i1rqy4v8";
const intervalPaddingCss = "ish3s31";
const intervalStrikethroughCss = "i1yq5ydv";
const intervalCss = "i1ynd34s";
const Interval = forwardRef((props, ref) => {
  const {
    inactive,
    padding,
    strikethrough,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(intervalCss, {
    [intervalInactiveCss]: inactive,
    [intervalPaddingCss]: padding,
    [intervalStrikethroughCss]: strikethrough
  }, props.className)} />;
});
const moreCss = "m1ltqhqh";
const More = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(moreCss, props.className)} />;
});
const Holiday = ({
  holiday
}) => {
  if (!holiday) return null;
  return <Interval padding strikethrough={!holiday.enabled}>
      {holiday.name}
    </Interval>;
};
const DateSpecificIntervals = ({
  holiday,
  inactive,
  intervals,
  maxToShow
}) => {
  if (!intervals) return null;
  if (holiday?.enabled) return null;
  const shouldShowMore = intervals.length > maxToShow;
  const intervalsToShow = shouldShowMore ? intervals.slice(0, maxToShow - 1) : intervals;
  return <>
      {intervals.length === 0 && <Interval inactive>{I18n.t('publisher.event_types.availability.unavailable')}</Interval>}
      {intervalsToShow.map(({
      from,
      to
    }) => <Interval key={`${from}-${to}`} inactive={inactive}>
          <FormattedTime value={from} />
          {' – '}
          <FormattedTime value={to} />
        </Interval>)}
      {shouldShowMore && <More>{I18n.t('publisher.availability.schedules.more_intervals', {
        count: intervals.length - (maxToShow - 1)
      })}</More>}
    </>;
};
const Intervals = ({
  holiday,
  intervals,
  inactive,
  reduceToFit
}) => {
  const ref = useRef();
  const amountToSubtract = holiday ? 1 : 0;
  const [maxToShow, setMaxToShow] = useState(4);
  const {
    width: windowWidth,
    height: windowHeight
  } = useWindowSize();
  useLayoutEffect(() => {
    if (reduceToFit) {
      const {
        height
      } = ref.current.getBoundingClientRect();
      const maxThatCouldFit = Math.round(height / 26);
      const potentialMax = Math.max(maxThatCouldFit, 2);
      setMaxToShow(Math.min(potentialMax, 10));
    }
  }, [setMaxToShow, reduceToFit, windowWidth, windowHeight]);
  return <Container ref={ref}>
      <PositionWrapper>
        <Holiday holiday={holiday} />
        <DateSpecificIntervals holiday={holiday} inactive={inactive} intervals={intervals} maxToShow={maxToShow - amountToSubtract} />
      </PositionWrapper>
    </Container>;
};
export default Intervals;

require("./intervals.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./intervals.js");